import React from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from 'react-router-dom';

import { Footer } from 'component/Footer/Footer';

import { PageLoading } from './component/PageLoading/PageLoading';
import FollowUs from './page/promote/FollowUs/FollowUs';
import Record from './page/exercise/Record/Record';
import Pay from './page/user/Pay/Pay';
import PayLanding from './page/skill/PayLanding/PayLanding';
import UserCenter from './page/user/UserCenter/UserCenter';

import RecordAnalysis from './page/record/RecordAnalysis/RecordAnalysis';
const SkillDailyRecord = React.lazy(() => import('./page/record/SkillDailyRecord/SkillDailyRecord'));
const RecordFailList = React.lazy(() => import('./page/record/RecordFailList/RecordFailList'));
const MyFailBook = React.lazy(() => import('./page/record/MyFailBook/MyFailBook'));
const RecordIndex = React.lazy(() => import('./page/record/RecordIndex/RecordIndex'));
const RecordTypeIndex = React.lazy(() => import('./page/record/RecordTypeIndex/RecordTypeIndex'));
const RecordRank = React.lazy(() => import('./page/record/AppRank/AppRank'));

const FeedBack = React.lazy(() => import('./page/user/FeedBack/FeedBack'));
const BindPhone = React.lazy(() => import('./page/user/BindPhone/BindPhone'));
const BindDevice = React.lazy(() => import('./page/user/BindDevice/BindDevice'));
const BindXiaoMi = React.lazy(() => import('./page/user/BindXiaoMi/BindXiaoMi'));
const BindByCode = React.lazy(() => import('./page/user/BindByCode/BindByCode'));

const AddExam = React.lazy(() => import('./page/user/exam/AddExam/AddExam'));
const ExamList = React.lazy(() => import('./page/user/exam/ExamList/ExamList'));
const ExamDetail = React.lazy(() => import('./page/user/exam/ExamDetail/ExamDetail'));

const SkillList = React.lazy(() => import('./page/skill/SkillList/SkillList'));

const PayCancel = React.lazy(() => import('./page/pay/PayCancel/PayCancel'));
const PaySuccess = React.lazy(() => import('./page/pay/PaySuccess/PaySuccess'));

const LessonList = React.lazy(() => import('./page/lesson/List/List'));

const Privacy = React.lazy(() => import('./page/compliance/privacy/Privacy'));
const UserServiceProtocol = React.lazy(() => import('./page/compliance/userService/UserService'));

const VipNotice = React.lazy(() => import('./page/compliance/vip/vip'));


function App() {
  return (
      <Router>
          <div className="app">
              <Switch>
                  <Route path="/mp/user/center" exact>
                      <PageLoading><UserCenter /></PageLoading>
                  </Route>
                  <Route path="/mp/user/feedback" exact>
                      <PageLoading><FeedBack /></PageLoading>
                  </Route>
                  <Route path="/mp/user/bindPhone" exact>
                      <PageLoading><BindPhone /></PageLoading>
                  </Route>
                  <Route path="/mp/user/bindDevice" exact>
                      <PageLoading><BindDevice /></PageLoading>
                  </Route>
                  <Route path="/mp/user/bindXiaoMi" exact>
                      <PageLoading><BindXiaoMi /></PageLoading>
                  </Route>
                  <Route path="/mp/user/bindByCode" exact>
                      <PageLoading><BindByCode /></PageLoading>
                  </Route>
                  <Route path="/mp/user/exam/list" exact>
                      <PageLoading><ExamList /></PageLoading>
                  </Route>
                  <Route path="/mp/user/exam/detail" exact>
                      <PageLoading><ExamDetail /></PageLoading>
                  </Route>
                  <Route path="/mp/user/exam/create" exact>
                      <PageLoading><AddExam /></PageLoading>
                  </Route>
                  <Route path="/mp/record" exact>
                      <PageLoading><RecordIndex /></PageLoading>
                  </Route>
                  <Route path="/mp/record/analysis" exact>
                      <PageLoading><RecordAnalysis /></PageLoading>
                  </Route>
                  <Route path="/mp/record/rank" exact>
                      <PageLoading><RecordRank /></PageLoading>
                  </Route>
                  <Route path="/mp/record/type" exact>
                      <PageLoading><RecordTypeIndex /></PageLoading>
                  </Route>
                  <Route path="/mp/record/failList" exact>
                      <PageLoading><RecordFailList /></PageLoading>
                  </Route>
                  <Route path="/mp/record/myFailBook" exact>
                      <PageLoading><MyFailBook /></PageLoading>
                  </Route>
                <Route path="/mp/record/skillDailyRecord" exact>
                  <PageLoading><SkillDailyRecord /></PageLoading>
                </Route>
                  <Route path="/mp/promote/follow" exact>
                      <FollowUs />
                  </Route>
                  <Route path="/mp/exercise/record" exact>
                      <Record />
                  </Route>
                  <Route path="/mp/user/pay" exact>
                      <Pay />
                  </Route>
                  <Route path="/wx/sale" exact>
                      <PayLanding />
                  </Route>
                  <Route path="/alipay/sale" exact>
                      <PayLanding />
                  </Route>
                  <Route path="/mp/pay/cancel" exact>
                      <PageLoading>
                          <PayCancel />
                      </PageLoading>
                  </Route>
                  <Route path="/mp/pay/success" exact>
                      <PageLoading>
                          <PaySuccess />
                      </PageLoading>
                  </Route>
                  <Route path="/mp/skillList" exact>
                      <PageLoading><SkillList /></PageLoading>
                  </Route>
                <Route path="/mp/lesson/list" exact>
                  <PageLoading><LessonList /></PageLoading>
                </Route>
                <Route path="/mp/compliance/privacy" exact>
                  <PageLoading><Privacy /></PageLoading>
                </Route>
                <Route path="/mp/compliance/userService" exact>
                  <PageLoading><UserServiceProtocol /></PageLoading>
                </Route>
                <Route path="/mp/compliance/vipNotice" exact>
                  <PageLoading><VipNotice /></PageLoading>
                </Route>
              </Switch>
              {/*<Footer/>*/}
          </div>
      </Router>
  );
}

export default App;
